import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { useRouter } from 'next/router'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import type { UseQueryClearOptions } from 'shared/types/tanstack-utility-types'
import { templatesKeys } from '../api/key-factory'
import { TEMPLATES_API } from '../api/templates-api'
import type { TemplatesCategoryInterface } from '../types/templates-category-interface'

export const useTemplateCategories = (
  options: UseQueryClearOptions<
    TemplatesCategoryInterface[],
    Error,
    TemplatesCategoryInterface[]
  > = {},
): UseQueryResult<TemplatesCategoryInterface[]> => {
  const { locale, isReady } = useRouter()
  const { fetcher } = useApiWrapperWithErrorValidation<
    RequestMethodsEnum.get,
    TemplatesCategoryInterface[]
  >({ method: RequestMethodsEnum.get })

  return useQuery({
    queryKey: templatesKeys.categories(locale),
    queryFn: async () => fetcher(`${TEMPLATES_API}/filter/categories/${locale}`),
    enabled: isReady && !!locale,
    gcTime: Infinity,
    retry: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: 'always',
    ...options,
  })
}
